module.exports = __webpack_public_path__ + "img/uo.8b0947c4.jpg";